import React from 'react';

import Component from '../../Component';
import { h6, h5, bold, subTitle1, subTitle2 } from '../../../resources/styles';
import { getImage } from '../../../resources/images';
import { merge } from '../../../utils';
import VideoCard from '../../VideoCard';
import Oyo from '../../../resources/vectors/oyo';

class Testimonial extends Component {

    render = () => <div style={merge(styles.container, this.props.style)} className={this.props.className}>
        <img src={getImage('white-hotel-room.jpeg')} alt='white-hotel-room' style={styles.image} />
        <div style={styles.content}>
            <VideoCard youtubeID='wcvZoCjulGQ' thumbnail={getImage('thumb1.png')} title='Mr. Abdul Nihaf' description='Mr. Abdul speaks about staff culture and training' style={styles.video} />
            <div style={{ padding: 24 }}>
                <div style={styles.title}>Mr. Abdul Nihaf</div>
                <div style={styles.subTitle}>- a hotel owner in bangalore</div>
                <div style={styles.description}>"Found a great partner in OYO, because of which I was able to grow so quickly"</div>
            </div>
        </div>
        <div style={styles.joinOyo}>Join&nbsp;<Oyo style={styles.OYO} />&nbsp;</div>
    </div>;

}

export default Testimonial;

const styles = {

    container: { height: 350, width: 700, position: 'relative', borderRadius: 10, overflow: 'hidden', boxShadow: 'var(--shadow-dark)'  },

    image: { height: '100%', width: '100%', objectFit: 'cover' },

    content: { position: 'absolute', top: 0, display: 'flex', padding: 24 },

    video: { boxShadow: 'var(--shadow)' },

    title: { ...h6, ...bold },

    subTitle: { ...subTitle2, marginLeft: 20 },

    description: { ...subTitle1, marginTop: 24 },

    joinOyo: { ...h6, padding: 16, position: 'absolute', bottom: 0, right: 0, boxSizing: 'border-box' },

    OYO: { position: 'relative', top: 2 },

    icon: { transform: 'rotate(16deg)', marginRight: 8 },

};